var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelperField } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import * as React from 'react';
import styles from './conditionVariableSelector.module.scss';
export class ConditionVarSelector extends React.PureComponent {
    hasError() {
        const { meta } = this.props;
        if (meta === null || meta === void 0 ? void 0 : meta.error) {
            return (meta === null || meta === void 0 ? void 0 : meta.touched) === true;
        }
        return false;
    }
    getErrorMessage() {
        if (this.hasError()) {
            const { meta } = this.props;
            return meta === null || meta === void 0 ? void 0 : meta.error;
        }
        return undefined;
    }
    onChange(event) {
        const { input, variables } = this.props;
        const value = event.target.value;
        const item = variables
            .flatMap((optGroup) => optGroup.items)
            .find((item) => item.item.variableType === value);
        if (item) {
            input.onChange(item.item);
        }
    }
    render() {
        const _a = this.props, { className, input, label, meta, placeholder, required, disabled, variables } = _a, otherProps = __rest(_a, ["className", "input", "label", "meta", "placeholder", "required", "disabled", "variables"]);
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        return (_jsx("div", Object.assign({}, otherProps, { className: rootClass }, { children: _jsx(HelperField, Object.assign({ label: label, errorMessage: this.getErrorMessage(), required: required, fieldId: input.name }, { children: _jsxs("select", Object.assign({ className: styles.input, id: input.name, disabled: disabled, onChange: this.onChange, value: input.value.variableType }, { children: [!!placeholder && (_jsx("option", Object.assign({ hidden: true, value: "" }, { children: placeholder }))), variables.map((optGroup) => (_jsx("optgroup", Object.assign({ label: optGroup.label }, { children: optGroup.items.map((option) => (_jsx("option", Object.assign({ value: option.item.variableType }, { children: option.name }), option.item.variableType))) }), optGroup.label)))] })) })) })));
    }
}
__decorate([
    boundMethod
], ConditionVarSelector.prototype, "onChange", null);
